import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (MEASUREMENT_ID) {
  ReactGA.initialize(MEASUREMENT_ID);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // react-router v6 emits deprecation warnings for behavior that will
  // change in v7 unless opted in explicitly. Enabling both flags now
  // matches how the app already works (we don't rely on either old
  // behavior) and silences the console noise without committing to the
  // v7 upgrade. Safe to remove when the project migrates to v7.
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
);
